/**
 * ⚙️ Configuración de Ecommerce Público (Landing / Menú)
 *
 * Aquí definimos las modalidades de pedido y métodos de pago
 * que estarán disponibles en la página pública.
 *
 * Si un negocio no ofrece una modalidad o método,
 * basta con poner `enabled: false` y desaparecerá del checkout.
 */

export type PublicServiceModeId = 'delivery' | 'pickup' | 'dine_in';

interface PublicServiceMode {
  id: PublicServiceModeId;
  label: string;
  description?: string;
  enabled: boolean;
}

export type PublicPaymentMethodId = 'cash' | 'card' | 'yape' | 'plin' | 'transfer' | 'wallet' | 'online';

interface PublicPaymentMethod {
  id: PublicPaymentMethodId;
  label: string;
  description?: string;
  enabled: boolean;
}

export const PUBLIC_SERVICE_MODES: PublicServiceMode[] = [
  {
    id: 'delivery',
    label: 'Delivery',
    description: 'Coordinamos el envío a tu dirección.',
    enabled: true,
  },
  {
    id: 'pickup',
    label: 'Retiro',
    description: 'Lo recoges en barra o mostrador.',
    enabled: true,
  },
  {
    id: 'dine_in',
    label: 'Comer en el local',
    description: 'Prepararemos tu pedido para consumir en sala.',
    enabled: false,
  },
];

export const PUBLIC_PAYMENT_METHODS: PublicPaymentMethod[] = [
  {
    id: 'cash',
    label: 'Efectivo',
    description: 'Pagas en efectivo al recibir o al recoger.',
    enabled: true,
  },
  {
    id: 'card',
    label: 'Tarjeta',
    description: 'Pagas con tarjeta en el local o con POS.',
    enabled: true,
  },
  {
    id: 'yape',
    label: 'Yape',
    description: 'Te compartimos el número para yapear.',
    enabled: true,
  },
  {
    id: 'plin',
    label: 'Plin',
    description: 'Te compartimos el número para plinear.',
    enabled: true,
  },
  {
    id: 'transfer',
    label: 'Transferencia',
    description: 'Te enviamos los datos para transferencia bancaria.',
    enabled: false,
  },
  {
    id: 'wallet',
    label: 'Wallet (Saldo pre-cargado)',
    description: 'Paga con el saldo de tu wallet y gana 2x puntos.',
    enabled: true,
  },
  {
    id: 'online',
    label: 'Pago online',
    description: 'Paga con tarjeta, Yape u otros medios a través de nuestra pasarela segura.',
    enabled: true,
  },
];

export const PUBLIC_CHECKOUT_CONFIG = {
  requireServiceMode: true,
  requirePaymentMethod: true,
};

